import Dashboard from "../../../../pages/platforms/frontdesk/dashboard";
import {
  PreAnalyticalConsumables,
  AnalyticalConsumables,
  PostAnalyticalConsumables,
} from "../../../../pages/platforms/frontdesk/offers/consumables";
import Medicines from "../../../../pages/platforms/frontdesk/market/medicines";
import Machines from "../../../../pages/platforms/frontdesk/market/machines";
import BrandProductsPage from "../../../../pages/platforms/laboratory/catalog/products";
import GenericProductsPage from "../../../../pages/platforms/laboratory/catalog/brandedProducts";
import {
  BrowseSupplies,
  SubmittedRequests,
  ToReceiveRequests,
  CompletedRequests,
  CancelledRequests,
} from "../../../../pages/platforms/frontdesk/supplyHub";

import {
  Fecalysis,
  Hematology,
  Urinalysis,
  Chemistry,
  Serology,
  Xray,
  Ultrasound,
  Ecg,
  Miscellaneous,
} from "../../../../pages/platforms/frontdesk/reports";
//import { HotlinesPoster } from "../../../../pages/platforms/cashier";

import { Reports } from "../../../../pages/platforms/laboratory/diagnostics";
import {
  Tasks,
  Onboard,
} from "../../../../pages/platforms/frontdesk/diagnostics";
import { Menus, Services } from "../../../../pages/platforms/cashier";
// import Products from "../../../../pages/platforms/frontdesk/market/products";
// import productsGenerics from "../../../../pages/platforms/frontdesk/market/productsGenerics";
// import generics from "../../../../pages/platforms/frontdesk/market/generics";
// import medicines from "../../../pages/platforms/frontdesk/market/medicine";
import mentainance from "../../../../pages/platforms/frontdesk/market/mentainance";
import { Billings } from "../../../../pages/platforms/frontdesk/Sendouts";
import { SOA } from "../../../../pages/platforms/cashier";
import { Status } from "../../../../pages/platforms/frontdesk";
import {
  Request,
  Clearance,
  Certification,
} from "../../../../pages/platforms/frontdesk/forms";

import Sendouts from "../../../../pages/platforms/laboratory/diagnostics/sendouts";

import Stocks from "../../../../pages/platforms/frontdesk/market/stocks";

const frontdesk = [
  {
    name: "Dashboard",
    icon: "tachometer-alt",
    path: "/dashboard",
    title:
      "Displays announcements and system-wide updates for the frontdesk team.",
    component: Dashboard,
  },
  {
    name: "Diagnostics",
    path: "/diagnostics",
    icon: "cogs",
    id: "frontdesk-diagnostics",
    title:
      "Manage patient diagnostics – onboarding, task queue, tracking, and sendouts.",
    children: [
      {
        name: "Onboarding",
        path: "/onboarding",
        icon: "tv",
        title: "Register and onboard patients for diagnostic procedures.",
        component: Onboard,
      },
      {
        name: "Tasks",
        path: "/tasks",
        icon: "clipboard-list",
        title: "View and manage pending diagnostic tasks for patients.",
        component: Tasks,
      },
      {
        name: "Tracker",
        path: "/reports",
        icon: "file-alt",
        title: "Monitor the progress and reports of diagnostics performed.",
        component: Reports,
      },
      {
        name: "Sendouts",
        path: "/sendouts",
        icon: "arrow-left",
        title: "Manage sendouts to external laboratories for outsourced tests.",
        component: Sendouts,
        allowedFor: ["Laboratory"],
      },
    ],
  },
  {
    name: "Outsourcing",
    icon: "tv",
    path: "/outsource",
    title:
      "obtain (goods or a service) from an outside or foreign laboratories, especially in place of an internal source",
    allowedFor: ["Laboratory"],
    children: [
      {
        name: "Status",
        path: "/status",
        icon: "file-invoice",
        title: "Track acceptance or rejection of outsourced tests.",
        component: Status,
      },
      {
        name: "Logbook",
        path: "/logbook",
        icon: "balance-scale",
        title: "View monthly records of sendouts and charging status.",
        component: SOA,
      },
      {
        name: "Billing (SOA)",
        path: "/billing",
        icon: "file-invoice",
        title: "Generate and view billing statements for outsourced services.",
        component: Billings,
      },
    ],
  },
  {
    name: "Supply Hub",
    path: "/supply-hub",
    icon: "warehouse",
    title:
      "Centralized platform for requesting clinic supplies handled by procurement.",
    children: [
      {
        name: "Browse Supplies",
        path: "/browse",
        icon: "boxes",
        title: "Browse available items for internal request.",
        component: BrowseSupplies,
      },
      // { put on topbar, save on indexDb
      //   name: "My Cart",
      //   path: "/cart",
      //   icon: "shopping-basket",
      //   title: "Add items for your request and submit to procurement.",
      //   component: CartComponent,
      // },
      {
        name: "My Requests",
        path: "/requests",
        icon: "tasks",
        title: "Track and manage your submitted supply requests.",
        children: [
          {
            name: "Submitted",
            path: "/submitted",
            icon: "file-invoice",
            title: "Requests that are awaiting procurement action.",
            component: SubmittedRequests,
          },
          {
            name: "To Receive",
            path: "/to-receive",
            icon: "clipboard-list",
            title:
              "Requests that have been approved and are ready for receipt.",
            component: ToReceiveRequests,
          },
          {
            name: "Completed",
            path: "/completed",
            icon: "check-circle",
            title: "Requests that have been successfully received.",
            component: CompletedRequests,
          },
          {
            name: "Cancelled",
            path: "/cancelled",
            icon: "ban",
            title: "Requests that were withdrawn or rejected.",
            component: CancelledRequests,
          },
        ],
      },
    ],
  },
  {
    name: "Merchandise",
    path: "/merchandise",
    icon: "boxes",
    title:
      "Manage inventory and product listings like machines, medicines, and consumables.",
    children: [
      {
        name: "Generic Products",
        path: "/productsGenerics",
        icon: "cubes",
        title:
          "Generic reagents and supplies, and the brands registered for each.",
        component: GenericProductsPage,
      },
      {
        name: "Products",
        path: "/products",
        icon: "tags",
        title: "Branded products tagged to their generic and suppliers.",
        component: BrandProductsPage,
      },
      {
        name: "Machines",
        path: "/merchandise/machines",
        icon: "laptop-code",
        title: "List and manage medical machines and diagnostic equipment.",
        component: Machines,
      },
      {
        name: "Medicines",
        path: "/medicines",
        icon: "pills",
        title: "Manage pharmaceutical stocks and generic drugs.",
        component: Medicines,
      },
      {
        name: "Mentainance",
        path: "/merchandise/mentainance",
        icon: "laptop-code",
        title: "Track machine maintenance and calibration schedules.",
        component: mentainance,
      },
      {
        name: "Stocks",
        path: "/merchandise/stocks",
        icon: "box",
        component: Stocks,
      },
    ],
  },
  {
    name: "Logbook Results",
    path: "/results",
    icon: "file-alt",
    children: [
      {
        name: "Chemistry",
        path: "/laboratory/chemistry",
        icon: "flask",
        component: Chemistry,
        allowedFor: ["Laboratory"],
      },
      {
        name: "Hematology",
        path: "/laboratory/hematology",
        icon: "blood",
        component: Hematology,
        allowedFor: ["Laboratory"],
      },
      {
        name: "Urinalysis",
        path: "/laboratory/urinalysis",
        icon: "toilet-paper",
        component: Urinalysis,
        allowedFor: ["Laboratory"],
      },
      {
        name: "Fecalysis",
        path: "/laboratory/fecalysis",
        icon: "smile",
        component: Fecalysis,
        allowedFor: ["Laboratory"],
      },
      {
        name: "Serology",
        path: "/laboratory/serology",
        icon: "microscope",
        component: Serology,
        allowedFor: ["Laboratory"],
      },
      {
        name: "Miscellaneous",
        path: "/laboratory/miscellaneous",
        icon: "list",
        component: Miscellaneous,
        allowedFor: ["Laboratory"],
      },
      {
        name: "ECG",
        path: "/radiology/ecg",
        icon: "heartbeat",
        component: Ecg,
        allowedFor: ["Radiology"],
      },
      {
        name: "Ultrasound",
        path: "/radiology/ultrasound",
        icon: "user-md",
        component: Ultrasound,
        allowedFor: ["Radiology"],
      },
      {
        name: "Xray",
        path: "/radiology/xray",
        icon: "x-ray",
        component: Xray,
        allowedFor: ["Radiology"],
      },
      {
        name: "CT",
        path: "/radiology/ct",
        icon: "user-md",
        // component: CtComponent, // add your component
        allowedFor: ["Radiology"],
      },
      {
        name: "MRI",
        path: "/radiology/mri",
        icon: "user-md",
        // component: MriComponent, // add your component here
        allowedFor: ["Radiology"],
      },
      {
        name: "2DEcho",
        path: "/radiology/mri",
        icon: "user-md",
        // component: MriComponent, // add your component here
        allowedFor: ["Radiology"],
      },
    ],
  },
  {
    name: "Catalogs",
    path: "/offers",
    icon: "list",
    children: [
      {
        name: "Menus",
        path: "/offers/menus",
        icon: "bars",
        component: Menus,
      },
      {
        name: "Services",
        path: "/offers/services",
        icon: "list",
        component: Services,
      },
      {
        name: "Consumables",
        icon: "tv",
        path: "/consumables",
        children: [
          {
            name: "Preanalytical",
            path: "/preanalytical",
            icon: "check-circle",
            title: "Supplies used before analysis, per service",
            component: PreAnalyticalConsumables,
          },
          {
            name: "Analytical",
            path: "/analytical",
            icon: "balance-scale",
            title: "Supplies used during analysis, per service",
            component: AnalyticalConsumables,
          },
          {
            name: "Postanalytical",
            path: "/postanalytical",
            icon: "thermometer-half",
            title: "Supplies used after analysis, per service",
            component: PostAnalyticalConsumables,
          },
        ],
      },
    ],
  },
  {
    name: "Request Form Templates",
    path: "/forms",
    icon: "clipboard-list",
    title: "downloadable forms",
    children: [
      {
        name: "Physician's Order Form",
        path: "/request",
        icon: "file-medical",
        title: "Physician's Order Form template",
        component: Request,
      },
      {
        name: "MEDICAL EXAMINATION CLEARANCE",
        path: "/clearance",
        icon: "file",
        title: "Medical Examination Clearance template",
        component: Clearance,
      },
      {
        name: "PHYSICAL EXAMINATION REPORT",
        path: "/certification",
        icon: "file",
        title: "Physical Examination Report template",
        component: Certification,
      },
    ],
  },
  // {
  //   name: "Hotlines",
  //   path: "/hotlines",
  //   icon: "phone-alt",
  //   title: "Emergency Hotlines Poster",
  //   component: HotlinesPoster,
  // },
];

export default frontdesk;
